export default class File {
  constructor(source) {
    this.url = source.url;
    this.size = source.size;
    this.name = source.original_name;
  }
}
